import { render, staticRenderFns } from "./AdminIdeasSelectModal.vue?vue&type=template&id=0907f1ea&scoped=true&"
import script from "./AdminIdeasSelectModal.vue?vue&type=script&lang=ts&"
export * from "./AdminIdeasSelectModal.vue?vue&type=script&lang=ts&"
import style0 from "./AdminIdeasSelectModal.vue?vue&type=style&index=0&id=0907f1ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0907f1ea",
  null
  
)

export default component.exports